async function deploy(request, config, build, logger = { error: () => {}, info: () => {} }) {
    const { branch } = build;
    if (branch && branch.toLowerCase() === 'master') {
        const { apiKey, authToken } = config;
        const options = {
            method: 'POST',
            uri: 'http://app.raygun.io/deployments',
            qs: { authToken },
            json: true,
            body: generateBody(apiKey, build),
        };

        let response;
        try {
            response = await request(options);
        } catch (error) {
            return logger.error('RAYGUN DEPLOYMENT FAILED', { error });
        }
        const { statusCode, statusMessage } = response;
        if (statusCode === 200) {
            return logger.info('RAYGUN DEPLOYMENT SUCCESSFUL');
        } else {
            return logger.error('RAYGUN DEPLOYMENT INVALID RESPONSE', { statusCode, statusMessage });
        }
    }
}

function generateBody(apiKey, build = { commit: { user: {} } }) {
    const { version, commit, scm, created } = build;
    const { hash, user, message } = commit;
    const { name, email } = user;
    return {
        apiKey,
        version,
        ownerName: name,
        emailAddress: email,
        comment: message,
        scmIdentifier: hash,
        scmType: scm,
        createdAt: created,
    };
}

export { deploy, generateBody };
